import { useAppSelector } from 'app/store/store';
import Clock from 'react-live-clock';
import tzlookup from 'tz-lookup';
import { utc } from 'app/helpers/timeHelper';
import moment from 'moment';
import { useMemo } from 'react';

interface LocalTimeProps {
  lat?: number;
  lon?: number;
}

//не апдейтится время в clock
export const LocalTime = ({ lat, lon }: LocalTimeProps) => {
  const profile = useAppSelector((state) => state.userSlice.profile);
  const timeFormat: string = useMemo(() => profile?.ui?.['timeFormat'] || 'HH:mm:ss', [profile]);
  const timeTitle = useMemo(() => {
    const format = timeFormat.split(':ss').join('');

    return moment().locale('en').format(format);
  }, [timeFormat]);

  if (lat !== undefined && lon !== undefined)
    return (
      <div title={timeTitle}>
        <Clock format={timeFormat} locale={'en'} ticking timezone={tzlookup(lat, lon)} noSsr />
        {`${' '}(UTC${utc(lat, lon)})`}
      </div>
    );
  else return null;
};
